if (!customElements.get('facets-expandible-button')) {
  customElements.define(
    'facets-expandible-button',
    class FacetsExpandibleButton extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.visibleCount = parseInt(this.dataset.visibleCount);
        this.totalCount = parseInt(this.dataset.totalCount);
        this.isExpanded = false;

        this.detailsParent = this.closest('details');
        this.labelShowMore = this.querySelector('.label-show-more');
        this.labelShowLess = this.querySelector('.label-show-less');

        this.isMobile = this.closest('.mobile-facets__details') !== null;
        this.parentContainer = this.isMobile
          ? this.closest('.mobile-facets__details')
          : this.closest('.parent-display');
      }

      get showMoreItems() {
        return this.detailsParent ? Array.from(this.detailsParent.querySelectorAll('.show-more-item')) : [];
      }

      connectedCallback() {
        this.button.addEventListener('click', (event) => {
          event.stopPropagation();
          event.preventDefault();
          event.stopImmediatePropagation();
          this.toggle();
        }, true);
      }

      toggle() {
        const wasOpen = this.detailsParent.open;

        if (this.isExpanded) {
          this.collapse();
        } else {
          this.expand();
        }

        if (wasOpen && !this.detailsParent.open) {
          this.detailsParent.open = true;
        }

        setTimeout(() => {
          this.updateParentAccordionHeight();
        }, 10);
      }

      expand() {
        this.showMoreItems.forEach((item, index) => {
          if (!item.classList.contains('hidden')) return;

          item.style.animationDelay = `${Math.min(index * 15, 120)}ms`;
          item.classList.add('show-more-item--entering');
          item.classList.remove('hidden');
          item.addEventListener('animationend', () => {
            item.classList.remove('show-more-item--entering');
            item.style.animationDelay = '';
          }, { once: true });
        });

        this.labelShowMore.classList.add('hidden');
        this.labelShowLess.classList.remove('hidden');
        this.isExpanded = true;

        if (this.parentContainer) this.parentContainer.classList.add('expanded');

        const nextElementToFocus = this.parentContainer ? this.parentContainer.querySelector('.show-more-item:not(.hidden) input') : null;
        if (nextElementToFocus) {
          nextElementToFocus.focus();
        }
      }

      collapse() {
        this.showMoreItems.forEach((item) => {
          item.classList.remove('show-more-item--entering');
          item.style.animationDelay = '';
          item.classList.add('hidden');
        });

        this.labelShowMore.classList.remove('hidden');
        this.labelShowLess.classList.add('hidden');

        this.isExpanded = false;

        if (this.parentContainer) this.parentContainer.classList.remove('expanded');
      }

      updateParentAccordionHeight() {
        if (this.detailsParent && typeof window.updateAccordionsHeight === 'function') {
          window.updateAccordionsHeight(this.detailsParent);
        }
      }
    }
  );
}
